"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestRackPowerStatusValidation = void 0;
class TestRackPowerStatusValidation {
    static isValid(entity) {
        // Validate entity.output_voltage_v for existence and correct type.
        if (entity.output_voltage_v == undefined)
            return false;
        if (typeof entity.output_voltage_v !== "number")
            return false;
        // Validate entity.output_current_a for existence and correct type.
        if (entity.output_current_a == undefined)
            return false;
        if (typeof entity.output_current_a !== "number")
            return false;
        // Validate entity.faulted for existence and correct type.
        if (entity.faulted == undefined)
            return false;
        if (typeof entity.faulted !== "boolean")
            return false;
        // Validate entity.max_current_a for existence and correct type.
        if (entity.max_current_a == undefined)
            return false;
        if (typeof entity.max_current_a !== "number")
            return false;
        // Validate entity.max_power_kw for existence and correct type.
        if (entity.max_power_kw == undefined)
            return false;
        if (typeof entity.max_power_kw !== "number")
            return false;
        // Validate entity.max_voltage_v for existence and correct type.
        if (entity.max_voltage_v == undefined)
            return false;
        if (typeof entity.max_voltage_v !== "number")
            return false;
        // Validate entity.min_voltage_v for existence and correct type.
        if (entity.min_voltage_v == undefined)
            return false;
        if (typeof entity.min_voltage_v !== "number")
            return false;
        return true;
    }
}
exports.TestRackPowerStatusValidation = TestRackPowerStatusValidation;
